import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Profile } from 'core/models';
import { ROLES } from 'core/services/assets/constants';
import { ClientsService, ProfileService } from 'core/services';

export const PartnerClientResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  clientsService: ClientsService = inject(ClientsService),
  profileService: ProfileService = inject(ProfileService)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const loggedUser: Profile = profileService.getLoggedUser();

    const clientId = [ROLES.DISTRIBUTOR, ROLES.EXPERT].includes(loggedUser.role) ? loggedUser.clientId : null;
    if (clientId) {
      const query = { _id: clientId, populate: 'partner' };
      clientsService
        .fetch(query)
        .then((remoteClients) => {
          return resolve(remoteClients.docs[0]);
        })
        .catch((error) => reject(error));
    } else {
      return resolve(null);
    }
  });
};
// lastValueFrom()
